export class TrendingTopicsEnvironment {
  public static getName = () => 'benzinga-trending-topics';
  public static getEnvironment = (env: Record<string, string>) => ({
    proxyUrl: new URL(env.url ?? 'https://editorial-tools.benzinga.com/api/'),
    upstreamUrl: new URL(env.upstreamUrl ?? 'https://editorial-tools.benzinga.com/api/'),
  });
}
